<template>
  <div>
    <PageMain
      ref="main"
      :loading="loading"
      :tableData="tableData"
      :disabled="disabled"
      @reload="getData()"
      @edit-reload="$emit('reload')"
    >
      <template #header>
        <div class="d-flex align-items-stretch">
          <div class="side-frame"></div>
          <div class="d-flex align-items-center">
            <span style="font-size: 14px; color: #606266">
              {{ $l('table_header_title_sku') || '订单产品明细' }}
            </span>
            <el-divider direction="vertical" v-if="!disabled"></el-divider>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="chooseHxSkuVisible = true"
              v-if="!disabled"
            >
              {{ $l('btn_selectGoods') || '选择产品' }}
            </b-button>
          </div>
        </div>
      </template>
    </PageMain>

    <ChoosePlatformSku
      :visible.sync="chooseHxSkuVisible"
      :hxPreOrderCode="hxPreOrderCode"
      @confirm="chooseConfirm"
    />
  </div>
</template>
<script>
import PageMain from './main'
import ChoosePlatformSku from '../choose-platform-sku'
import EditLoading from '@/mixins/edit-loading'
export default {
  components: { PageMain, ChoosePlatformSku },
  mixins: [EditLoading],
  props: {
    disabled: { type: Boolean, default: false },
    hxPreOrderCode: { type: String, default: '' },
  },
  data() {
    return {
      tableData: [],
      loading: false,
      chooseHxSkuVisible: false,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.hxPreOrderCode) return
      this.loading = true
      const params = { hxPreOrderCode: this.hxPreOrderCode }
      const res = await this.$api
        .ecomHxPreOrderDetailListApi(params)
        .catch(() => null)
      this.loading = false
      this.tableData = res?.body?.data || []
    },
    async chooseConfirm(data) {
      if (!data?.length) return
      const listHxSkuPlatformCode = data.map((item) => item.hxSkuPlatformCode)
      const params = {
        hxPreOrderCode: this.hxPreOrderCode,
        listHxSkuPlatformCode,
      }
      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomHxPreOrderDetailAddApi(params)
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      this.getData()
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 5px;
  border-left: 3px solid $color-primary;
  margin-top: 3px;
  margin-bottom: 3px;
}
</style>
